import {
  Record,
  String as RTString,
  Boolean as RTBoolean,
  Static,
  Array as RTArray,
  Number as RTNumber
} from 'runtypes';
import { DeepPartial } from 'utility-types';
import { buildService } from './decorated-service';

const ConsentService = buildService('/nasu-svc/service/consent');

const CreateConsentArgs = Record({
  consentee: Record({
    firstName: RTString,
    lastName: RTString,
    emailAddress: RTString
  }),
  didConsent: RTBoolean,
  termsAndConditionsIDs: RTArray(RTNumber)
});

export type StaticGetConsentArgs = Static<typeof CreateConsentArgs>;

export const postConsent = (
  args: DeepPartial<StaticGetConsentArgs>
): Promise<any> => {
  const validated: StaticGetConsentArgs = CreateConsentArgs.check(args);
  return ConsentService.add(validated);
};
